jQuery(function($) {

    // We can attach the `fileselect` event to all file inputs on the page
    $(document).on('change', ':file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            labels = [];

        for(var i = 0; i < input.get(0).files.length; i++) {
            labels.push(input.get(0).files[i].name);
        }

        var label = labels.join(', ').replace(/\\/g, '/').replace(/.*\//, '');

        input.trigger('fileselect', [numFiles, label]);
    });

    $(document).on('dragover dragenter dragleave', ':file', function(e) {
        e.preventDefault();
        e.stopPropagation();
    })
        .on('dragover dragenter', ':file', function() {
            $(this).parent().addClass('is-dragover');
        })
        .on('dragleave dragend drop', ':file', function() {
            $(this).parent().removeClass('is-dragover');
        });

    // We can watch for our custom `fileselect` event like this
    $(document).ready(function() {
        $(':file').on('fileselect', function(event, numFiles, label) {
            var input = $(this).parents('label');

            if(input.length && label) {
                input.attr('data-text', label);
            }

        });
    });

});
